import React from 'react'
import { withFormsy } from 'formsy-react'

import FieldError from './../FieldError'
import ReactHtmlParser from 'html-react-parser'
import withBaseFormsy from './withBaseFormsy'

class Radio extends withBaseFormsy(React.Component) {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this)
  }

  changeValue(event, newValue) {
    // setValue() will set the value of the component, which in
    // turn will validate it and the rest of the form
    // Important: Don't skip this step. This pattern is required
    // for Formsy to work.
    // if (event && event.preventDefault) {
    //   event.preventDefault();
    // }

    this.setValue(event)
  }

  render() {
    // An error message is returned only if the component is invalid
    const errorMessage = this.props.getErrorMessage();
    const item = this.props.item || {}

    if(this.props.getValue() === undefined)
      return null

    return (
      <div className={this.props.className}>
        <label htmlFor={`${item.id}_0`}>
          {item.name}{this.props.required ? <span className="label-require">(必須)</span> : ""}<br/>
          {ReactHtmlParser(item.note)}
        </label>
        <div className="form-inline" style={{padding: 0}}>
          {item.format.radio.map((label, i) => <div key={`radio_${i}`} className="form-check col-md-6" style={{padding: 0, justifyContent:"flex-start"}}>
            <input
              onChange={(e) => this.changeValue(e, label)}
              onClick={this.props.onClick}
              value={label}
              placeholder={this.props.placeholder}
              id={`${item.id}_${i}`}
              className="form-control"
              type="radio"
              style={{height: "auto", marginRight: "4px", marginBottom: "2px"}}
              name={this.props.name}
              checked={this.props.getValue().radio === label}
            />
            <label htmlFor={`${item.id}_${i}`} className="radio-inline form-check-label" style={{paddingLeft: "4px", cursor: "pointer"}}>
              {label}
            </label>
          </div>)}
        </div>
        { errorMessage && <FieldError message={errorMessage} /> }
      </div>
    );
  }
}

export default withFormsy(Radio);
